export function exposeSandboxBuildMarker(): void {
  if (process.env.REACT_APP_WAVEGEN_SANDBOX !== "true") return;

  const marker = process.env.REACT_APP_WAVEGEN_SANDBOX_MARKER?.trim();
  if (!marker) {
    throw new Error(
      "REACT_APP_WAVEGEN_SANDBOX_MARKER is required in sandbox mode.",
    );
  }

  document.documentElement.dataset.wavegenSandboxMarker = marker;
}
